import './index.css';

const Grain = () => <div className="grain" aria-hidden />;

export default Grain;
